import { useEffect } from 'react';
import { faqs } from '../data';
import FAQ from './FAQ';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './faq.css';

const FAQS = () => {

    useEffect(
        ()=>{
            AOS.init({
                duration: 1000, 
                delay: 50, 
                easing: 'ease-in-out-cubic', 
                once: false,
            });
        }, []
    );

    return (
        <section className='faqs'>
        <div className="container faqs_container">
            <div data-aos="fade-up" className="faqs_header">
                <h1>Frequently Asked Questions</h1>
                <p>
                    We understand that you may have some questions about our services, so we&#39;ve compiled a list of frequently
                    asked questions to provide you with the information you need. If you have any further inquiries, please
                    don&#39;t hesitate to contact us.
                </p>
            </div>
            <div data-aos="fade-up" className="faqs_wrapper">
            {
                faqs.map(({id, question, answer}) => {
                return <FAQ key={id} question={question} answer={answer}/>
                })
            }
            </div>
        </div>
        </section>
    )
}

export default FAQS